import React from 'react';
import styled, { css } from 'styled-components';
import Check from '@catalogo/ui-americanas-desktop-svg/check.svg';

const Checkbox = ({ checked }) => (
  <Wrapper checked={checked}>
    <Check fill="#fff" width={25} height={25} />
  </Wrapper>
);

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  transition: all ease 0.1s;
  width: 18px;
  height: 18px;
  padding: 2px;
  margin: -9px 8px 0 0;
  fill: #fff;
  ${({ checked, theme }) => css`
    border: 1px solid #000;
    background: ${checked && theme.primaryColor};
    border-color: ${checked && theme.primaryColor};
  `};
`;

export default Checkbox;
